(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["module-hero-slider"] && !Shopify.designMode) return;
  try {
    
class ModuleHeroSlider extends HTMLElement {
  connectedCallback() {
    this.carousel = this.querySelector('carousel-swiper')
    this.sectionEl = this.closest('.shopify-section')
    this.pendingIndex = null
    this.prevButton = this.querySelector('[data-hero-prev]')
    this.nextButton = this.querySelector('[data-hero-next]')

    this.onPrevClick = () => { if (this.swiper) this.swiper.slidePrev() }
    this.onNextClick = () => { if (this.swiper) this.swiper.slideNext() }
    this.onBlockSelect = this.onBlockSelect.bind(this)
    this.onBlockDeselect = this.onBlockDeselect.bind(this)
    this.onSectionUnload = this.onSectionUnload.bind(this)
    this.syncActiveSlide = this.syncActiveSlide.bind(this)
    this.decorateBullets = this.decorateBullets.bind(this)
    this.syncBullets = this.syncBullets.bind(this)
    this.onBulletKey = this.onBulletKey.bind(this)

    if (this.prevButton) this.prevButton.addEventListener('click', this.onPrevClick)
    if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick)
    if (this.sectionEl) {
      this.sectionEl.addEventListener('shopify:block:select', this.onBlockSelect)
      this.sectionEl.addEventListener('shopify:block:deselect', this.onBlockDeselect)
      document.addEventListener('shopify:section:unload', this.onSectionUnload)
    }
    this.observeCopyHeights()

    if (this.dataset.slides === '1') return
    this.waitForSwiper()
  }

  // Mobile overlay: the scrim must be solid over the whole bottom-anchored copy box, and CSS cannot
  // know its height, so every overlaid slide gets --hero-copy-h from a ResizeObserver (which also
  // fires after the font swap and on resize). Paint-only, so no layout jump.
  observeCopyHeights() {
    if (!('ResizeObserver' in window)) return
    const copies = [...this.querySelectorAll('.module-hero-slider__overlay')]
      .map((overlay) => overlay.parentElement && overlay.parentElement.querySelector('.module-hero-slider__copy'))
      .filter(Boolean)
    if (!copies.length) return
    // Read every height first, then write, so several slides resizing together do not interleave
    // layout reads with style writes.
    this.copyObserver = new ResizeObserver((entries) => {
      const sizes = entries.map((entry) => {
        const box = entry.borderBoxSize && entry.borderBoxSize[0]
        return { slide: entry.target.closest('.module-hero-slider__slide'), height: box ? box.blockSize : entry.target.getBoundingClientRect().height }
      })
      for (const { slide, height } of sizes) {
        if (slide) slide.style.setProperty('--hero-copy-h', `${Math.ceil(height)}px`)
      }
    })
    copies.forEach((copy) => this.copyObserver.observe(copy))
  }

  disconnectedCallback() {
    this.teardown()
  }

  // The editor removes or re-renders a section without always disconnecting the element, so both
  // paths run the same teardown: cancel the Swiper poll, drop every listener.
  onSectionUnload(event) {
    if (!this.sectionEl || event.target !== this.sectionEl) return
    this.teardown()
  }

  teardown() {
    if (this.torndown) return
    this.torndown = true
    this.cancelSwiperPoll()
    if (this.sectionEl) {
      this.sectionEl.removeEventListener('shopify:block:select', this.onBlockSelect)
      this.sectionEl.removeEventListener('shopify:block:deselect', this.onBlockDeselect)
      document.removeEventListener('shopify:section:unload', this.onSectionUnload)
    }
    if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrevClick)
    if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick)
    if (this.pagination) this.pagination.removeEventListener('keydown', this.onBulletKey)
    if (this.copyObserver) this.copyObserver.disconnect()
    if (this.swiper) {
      this.swiper.off('slideChange', this.syncActiveSlide)
      this.swiper.off('paginationRender', this.decorateBullets)
      this.swiper.off('paginationUpdate', this.syncBullets)
      if (this.swiper.keyboard) this.swiper.keyboard.disable()
    }
  }

  cancelSwiperPoll() {
    if (this.pollFrame) window.cancelAnimationFrame(this.pollFrame)
    if (this.pollTimer) window.clearInterval(this.pollTimer)
    this.pollFrame = null
    this.pollTimer = null
  }

  onBlockSelect(event) {
    const slide = event.target.closest && event.target.closest('.module-hero-slider__slide')
    if (!slide || !this.contains(slide)) return
    const slides = [...this.querySelectorAll('.module-hero-slider__slide')]
    const index = slides.indexOf(slide)
    if (index < 0) return
    // A select can arrive before Swiper has initialised (the editor selects a block as soon as the
    // section renders). Remember it and apply it the moment Swiper is ready.
    if (this.swiper) this.swiper.slideTo(index)
    else this.pendingIndex = index
  }

  onBlockDeselect() {
    this.pendingIndex = null
  }

  applyPendingSlide() {
    if (this.pendingIndex === null || !this.swiper) return
    this.swiper.slideTo(this.pendingIndex)
    this.pendingIndex = null
  }

  // theme.js is deferred and can land late on a slow connection, so the poll never gives up: it
  // runs on animation frames for the first three seconds (cheap and immediate once Swiper lands)
  // and then drops to a half-second timer until the element is torn down.
  waitForSwiper() {
    const started = Date.now()
    const found = () => {
      const swiper = this.carousel && this.carousel.instance && this.carousel.instance.swiper
      if (!swiper) return false
      this.cancelSwiperPoll()
      this.swiper = swiper
      this.bindSwiper()
      return true
    }
    const tick = () => {
      if (this.torndown || found()) return
      if (Date.now() - started > 3000) {
        if (!this.pollTimer) this.pollTimer = window.setInterval(tick, 500)
        this.pollFrame = null
        return
      }
      this.pollFrame = window.requestAnimationFrame(tick)
    }
    tick()
  }

  bindSwiper() {
    // Keyboard shoppers: Swiper's keyboard module (arrow keys while the slider is in view) is off
    // by default in the shared instance; enable it for the hero only.
    if (this.swiper.keyboard) {
      this.swiper.params.keyboard = { ...(this.swiper.params.keyboard || {}), enabled: true, onlyInViewport: true }
      this.swiper.keyboard.enable()
    }
    this.swiper.on('slideChange', this.syncActiveSlide)
    // Swiper re-renders the bullets on every pagination render (init, slides added in the editor),
    // so the button semantics are re-applied each time rather than once.
    this.swiper.on('paginationRender', this.decorateBullets)
    this.swiper.on('paginationUpdate', this.syncBullets)
    this.pagination = this.querySelector('.swiper-pagination')
    if (this.pagination) this.pagination.addEventListener('keydown', this.onBulletKey)
    this.decorateBullets()
    this.syncActiveSlide()
    this.applyPendingSlide()
  }

  // Dots and arrows take the active slide's text colour so they stay visible when slides alternate
  // light and dark backgrounds; over a photo (bleed) the arrows also get a fill in the slide colour.
  syncActiveSlide() {
    if (!this.swiper) return
    const active = this.swiper.slides && this.swiper.slides[this.swiper.activeIndex]
    const slide = active && (active.querySelector('.module-hero-slider__slide') || active)
    const styles = slide ? getComputedStyle(slide) : null
    const colour = styles ? styles.getPropertyValue('--slide-text').trim() : ''
    const bg = styles ? styles.getPropertyValue('--slide-bg').trim() : ''
    if (colour) this.style.setProperty('--hero-dot', colour)
    else this.style.removeProperty('--hero-dot')
    if (bg) this.style.setProperty('--hero-bg', bg)
    else this.style.removeProperty('--hero-bg')
    this.setAttribute('data-active-layout', (slide && slide.getAttribute('data-layout')) || 'colour')
  }

  bullets() {
    return this.pagination ? [...this.pagination.querySelectorAll('.swiper-pagination-bullet')] : []
  }

  // The shared carousel renders the bullets as bare spans. Here they are the stepper a shopper can
  // jump with, so each one is a named, focusable button; the shared `outline-none` reset is dropped
  // so the hero's own :focus-visible ring can show.
  decorateBullets() {
    this.bullets().forEach((bullet, index) => {
      bullet.classList.remove('outline-none')
      bullet.setAttribute('role', 'button')
      bullet.setAttribute('tabindex', '0')
      bullet.setAttribute('aria-label', `Go to slide ${index + 1}`)
    })
    this.syncBullets()
  }

  syncBullets() {
    if (!this.swiper) return
    this.bullets().forEach((bullet, index) => {
      if (index === this.swiper.activeIndex) bullet.setAttribute('aria-current', 'true')
      else bullet.removeAttribute('aria-current')
    })
  }

  onBulletKey(event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return
    const bullet = event.target.closest && event.target.closest('.swiper-pagination-bullet')
    if (!bullet || !this.swiper) return
    const index = this.bullets().indexOf(bullet)
    if (index < 0) return
    event.preventDefault()
    this.swiper.slideTo(index)
  }
}

if (!customElements.get('module-hero-slider')) {
  customElements.define('module-hero-slider', ModuleHeroSlider)
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["module-logo-icon-strip"] && !Shopify.designMode) return;
  try {
    
// One row of logos, call-outs or ticks. Every row tracks its scroll end for the trailing fade.
// With "Animate when overflowing" on, the row also glides when its items are wider than the band,
// and swaps to a hand-scroll row while keyboard focus is inside it so the focused item is visible.
class ModuleLogoRow extends HTMLElement {
  connectedCallback() {
    if (this.dataset.bound === 'true') return
    this.dataset.bound = 'true'
    this.track = this.querySelector('.module-logo-icon-strip__track')
    this.group = this.track && this.track.querySelector('.module-logo-icon-strip__group')
    if (!this.group) return
    this.speed = 60 // px per second
    this.update = this.update.bind(this)
    this.markEnd = this.markEnd.bind(this)
    this.addEventListener('scroll', this.markEnd, { passive: true })
    this.queueUpdate = this.queueUpdate.bind(this)
    // The viewport's own width equals --strip-band once it glides, so it can never report a
    // change: watch the band and the inner column instead, and the window on top of them.
    this.observer = new ResizeObserver(this.queueUpdate)
    this.observer.observe(this.band() || this)
    if (this.parentElement) this.observer.observe(this.parentElement)
    window.addEventListener('resize', this.queueUpdate)
    if (this.dataset.marquee === 'true') {
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
      if (this.motionQuery.addEventListener) this.motionQuery.addEventListener('change', this.update)
      else this.motionQuery.addListener(this.update)
      // `animation-play-state` does not stop this track in Chrome, so pause through the Web
      // Animations API on the row itself (pointerenter/leave do not bubble from the heading).
      this.addEventListener('pointerenter', () => {
        this.hovered = true
        this.setPlayState('pause')
      })
      this.addEventListener('pointerleave', () => {
        this.hovered = false
        this.gesture = null
        if (!this.tapPaused) this.setPlayState('play')
      })
      // Touch users can pause with a tap. Track the whole gesture: a drag that returns to its
      // start is still a drag. Cancelled or off-row gestures cannot pause the next interaction,
      // and links keep their normal action.
      this.addEventListener('pointerdown', (e) => {
        this.gesture = { id: e.pointerId, x: e.clientX, y: e.clientY, moved: 0 }
      })
      this.addEventListener('pointermove', (e) => {
        const g = this.gesture
        if (!g || g.id !== e.pointerId) return
        g.moved = Math.max(g.moved, Math.hypot(e.clientX - g.x, e.clientY - g.y))
      })
      this.addEventListener('pointerup', (e) => this.toggleTapPause(e))
      this.addEventListener('pointercancel', () => { this.gesture = null })
      this.addEventListener('focusin', (e) => this.holdForFocus(e.target))
      this.addEventListener('focusout', (e) => {
        if (!this.contains(e.relatedTarget)) this.releaseFocus()
      })
    }
    this.update()
  }

  disconnectedCallback() {
    this.gesture = null
    if (this.observer) this.observer.disconnect()
    window.removeEventListener('resize', this.queueUpdate)
    if (this.motionQuery) {
      if (this.motionQuery.removeEventListener) this.motionQuery.removeEventListener('change', this.update)
      else this.motionQuery.removeListener(this.update)
    }
  }

  // One update per frame, however many observers and resize events fire.
  queueUpdate() {
    if (this.frame) return
    this.frame = requestAnimationFrame(() => {
      this.frame = 0
      this.update()
    })
  }

  band() {
    return this.closest('.module')
  }

  // Chrome keeps `Animation.playState` running under `animation-play-state: paused`, so the
  // pause runs through the animation objects themselves.
  setPlayState(state) {
    if (!this.track) return
    this.track.getAnimations().forEach((animation) => animation[state]())
  }

  // Width of the live items laid out on one row: item widths plus the gaps between them. Summing
  // (rather than first-left to last-right) stays valid when the static row is in wrap mode.
  contentWidth() {
    const items = [...this.group.children].filter((el) => !el.hidden)
    if (!items.length) return 0
    const gap = parseFloat(getComputedStyle(this.group).columnGap) || 0
    return items.reduce((sum, el) => sum + el.getBoundingClientRect().width, 0) + gap * (items.length - 1)
  }

  // The band's content box (the shell's inner column), which is what the items must fit; the
  // viewport's own width changes with the glide breakout, so it is not the reference.
  availableWidth() {
    const inner = this.parentElement
    const cs = getComputedStyle(inner)
    return inner.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight)
  }

  update() {
    if (!this.clientWidth) return
    if (this.dataset.marquee !== 'true' || this.focusHeld) {
      this.markEnd()
      return
    }
    const run = !this.motionQuery.matches && this.contentWidth() > this.availableWidth() + 1
    if (!run) {
      this.setStatic()
      this.markEnd()
      return
    }
    // Re-read the band on every update: a resize changes it, and the clone count, shift and
    // duration are all measured against it.
    const band = this.band()
    const bandWidth = band ? band.clientWidth : this.clientWidth
    this.style.setProperty('--strip-band', `${bandWidth}px`)
    this.classList.add('is-marquee')
    this.classList.remove('has-more')
    const width = this.group.getBoundingClientRect().width
    if (!width) {
      this.setStatic()
      return
    }
    // Enough copies that the track covers the band twice, so the loop point never shows a gap.
    this.fill(Math.max(2, Math.ceil((bandWidth * 2) / width)))
    this.style.setProperty('--marquee-shift', `${width}px`)
    this.style.setProperty('--marquee-duration', `${width / this.speed}s`)
    if (this.hovered || this.tapPaused) this.setPlayState('pause')
  }

  toggleTapPause(e) {
    const g = this.gesture
    if (!g || g.id !== e.pointerId) return
    this.gesture = null
    if (Math.max(g.moved, Math.hypot(e.clientX - g.x, e.clientY - g.y)) > 8) return
    if (!this.classList.contains('is-marquee') || e.target.closest('a, button')) return
    this.tapPaused = !this.tapPaused
    this.toggleAttribute('data-paused', this.tapPaused)
    // A mouse that is still over the row keeps the hover pause; a touch pointer leaves right after.
    this.setPlayState(this.tapPaused || (this.hovered && e.pointerType === 'mouse') ? 'pause' : 'play')
  }

  setStatic() {
    this.classList.remove('is-marquee')
    this.style.removeProperty('--strip-band')
    this.style.removeProperty('--marquee-shift')
    this.style.removeProperty('--marquee-duration')
    this.track.querySelectorAll('[data-marquee-clone]').forEach((el) => el.remove())
  }

  // Trailing fade off once the row is scrolled to its end (or never overflowed).
  markEnd() {
    if (this.classList.contains('is-marquee')) return
    this.classList.toggle('has-more', this.scrollLeft + this.clientWidth < this.scrollWidth - 1)
  }

  // Focus inside a gliding row: hold it as a hand-scroll row and bring the focused item into view.
  holdForFocus(target) {
    if (!this.classList.contains('is-marquee') && !this.focusHeld) return
    this.focusHeld = true
    this.setStatic()
    this.classList.add('is-hand-scroll')
    target.scrollIntoView({ block: 'nearest', inline: 'center' })
    this.markEnd()
  }

  releaseFocus() {
    if (!this.focusHeld) return
    this.focusHeld = false
    this.classList.remove('is-hand-scroll')
    this.scrollLeft = 0
    this.update()
  }

  fill(copies) {
    const clones = [...this.track.querySelectorAll('[data-marquee-clone]')]
    for (let i = clones.length; i < copies - 1; i++) {
      const clone = this.group.cloneNode(true)
      clone.setAttribute('aria-hidden', 'true')
      clone.setAttribute('inert', '')
      clone.setAttribute('data-marquee-clone', '')
      clone.removeAttribute('role')
      clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'))
      this.track.appendChild(clone)
    }
    for (let i = clones.length - 1; i >= copies - 1; i--) clones[i].remove()
  }
}

if (!customElements.get('module-logo-row')) {
  customElements.define('module-logo-row', ModuleLogoRow)
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["module-shop-by-category"] && !Shopify.designMode) return;
  try {
    
class ModuleShopByCategory extends HTMLElement {
  connectedCallback() {
    if (this.bound) return
    this.bound = true
    this.triggers = [...this.querySelectorAll('[data-tab-trigger]')]
    this.panels = [...this.querySelectorAll('[data-tab-panel]')]
    this.tablist = this.querySelector('[data-tablist]')
    this.sectionEl = this.closest('.shopify-section')

    this.onTriggerClick = this.onTriggerClick.bind(this)
    this.onKeyDown = this.onKeyDown.bind(this)
    this.onBlockSelect = this.onBlockSelect.bind(this)
    this.onSectionUnload = this.onSectionUnload.bind(this)

    if (this.triggers.length < 2) return

    this.triggers.forEach((btn) => {
      this.tablist.appendChild(btn)
      btn.addEventListener('click', this.onTriggerClick)
      btn.hidden = false
    })
    this.tablist.addEventListener('keydown', this.onKeyDown)
    if (this.sectionEl) {
      this.sectionEl.addEventListener('shopify:block:select', this.onBlockSelect)
      document.addEventListener('shopify:section:unload', this.onSectionUnload)
    }
  }

  disconnectedCallback() {
    this.teardown()
  }

  onSectionUnload(event) {
    if (!this.sectionEl || event.target !== this.sectionEl) return
    this.teardown()
  }

  teardown() {
    if (!this.bound) return
    this.bound = false
    this.triggers.forEach((btn) => btn.removeEventListener('click', this.onTriggerClick))
    if (this.tablist) this.tablist.removeEventListener('keydown', this.onKeyDown)
    if (this.sectionEl) {
      this.sectionEl.removeEventListener('shopify:block:select', this.onBlockSelect)
      document.removeEventListener('shopify:section:unload', this.onSectionUnload)
    }
  }

  select(index, opts) {
    const focus = !opts || opts.focus !== false
    this.triggers.forEach((btn, i) => {
      const on = i === index
      btn.setAttribute('aria-selected', on ? 'true' : 'false')
      btn.tabIndex = on ? 0 : -1
      if (this.panels[i]) this.panels[i].hidden = !on
    })
    if (focus && this.triggers[index]) this.triggers[index].focus()
  }

  onTriggerClick(event) {
    const i = this.triggers.indexOf(event.currentTarget)
    if (i >= 0) this.select(i, { focus: false })
  }

  onKeyDown(event) {
    const i = this.triggers.findIndex((t) => t.getAttribute('aria-selected') === 'true')
    let next = i
    if (event.key === 'ArrowRight') next = (i + 1) % this.triggers.length
    else if (event.key === 'ArrowLeft') next = (i - 1 + this.triggers.length) % this.triggers.length
    else if (event.key === 'Home') next = 0
    else if (event.key === 'End') next = this.triggers.length - 1
    else return
    event.preventDefault()
    this.select(next, { focus: true })
  }

  onBlockSelect(event) {
    const tab = event.target.closest('[data-audience-tab]')
    if (!tab || !this.contains(tab)) return
    const panel = tab.querySelector('[data-tab-panel]')
    const i = this.panels.indexOf(panel)
    if (i >= 0) this.select(i, { focus: false })
  }
}

if (!customElements.get('module-shop-by-category')) {
  customElements.define('module-shop-by-category', ModuleShopByCategory)
}

  } catch(e) { console.error(e); }
})();
})();
